<template>
  <div class="mob-inject">
    <template v-if="homeShow">
       <!-- 場景選擇 -->
            <scene-select
                    :no-bg="false"
                    @changeScene="loadScene"
                    :sel-scene="selectScene"
            ></scene-select>
        <div class="add-box">
          <div class="add-inject" @click="toSettingAngle">{{$t('edit.angle.angleRange')}}</div>
        </div>
    </template>
    <template v-if="settingShow">
      <AngleSeeting
        @onClickBack="changeToShowHome"
        @saveDataToStore="saveDataToStore"
        @change="handleHotspotChange"
      ></AngleSeeting>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Steps from "../Steps.vue";
import TextItem from "../TextItem";
import TPItem from "../TPItem";
import AngleSeeting from "./component/AngleSetting.vue";
import SceneSelect from "../scenes/SceneSelect";

export default {
  components: { AngleSeeting, TPItem, TextItem, Steps ,SceneSelect},
  data() {
    return {
      hotspotObj: {},
      homeShow: true,
      settingShow: false,
      isAddNew: true,
      showAddPannel: false,
      editTarget: null,
      currHotId: "",
      currentTypeItem: {},
       selectScene:[],
    };
  },
  watch: {
    currentScenesId:{
       handler(newVal){
         this.$set(this.selectScene, 0, newVal);
         this.handleInitListData();
       }
    },
  },
  created() {
    this.handleInitListData();
    this.selectScene[0] = this.currentScenesId;
  },
  computed: { ...mapGetters(["vrbase", "currentScenesId"]) },
  methods: {
    // 這裡過濾掉scene類型的數據
    handleInitListData() {
      const hotports = this.vrbase.scenes[this.currentScenesId].hotspot;
      let tempObj = {};
      for (let key in hotports) {
        if (hotports[key].type === "scene") {
          tempObj[key] = hotports[key];
        }
      }
      this.hotspotObj = tempObj;
    },
    toSettingAngle() {
      this.isAddNew = true;
      this.editTarget = null;
      // this.showAddPannel = true;
      this.settingShow = true;
      this.homeShow = false;
    },
    onClickItem(value) {
      this.currHotId = value.hotspot_id;
      lookto(value.ath, value.atv);
      this.editTarget = value;
    },
    onClickType(item) {
      this.currentTypeItem = item;
    },
    onClickNext() {
      if (this.currentTypeItem.type) {
        this.changeToShowHome(this.currentTypeItem.type);
      } else {
        this.$message.error(this.$t('edit.editMessage.hotPSelect'))
      }
    },
    changeToShowHome() {
      this.settingShow = false;
      this.homeShow = true;
    },
    saveDataToStore({ key, data }) {
      this.changeToShowHome();
      let vrbase = this.vrbase;
      this.$set(this.hotspotObj, key, data); // 更新本地
      vrbase.scenes[this.currentScenesId].hotspot[key] = data;
      this.$store.dispatch("setVRBase", vrbase);
      // this.showAddPannel = false; //增加數據後顯示增加的 數據
    },
    deleteItem() {
      const selectedItem = this.editTarget;
      let hotspot = this.vrbase.scenes[this.currentScenesId].hotspot;
      this.$delete(hotspot, selectedItem.hotspot_id);
      this.$delete(this.hotspotObj, selectedItem.hotspot_id);
      this.$store.dispatch("setVRBase", this.vrbase);
      removeHotspot(selectedItem.hotspot_id);
    },
    editItem() {
      this.changeToShowHome(this.editTarget.type, false);
    },
    handleHotspotChange(val, oldVal) {
      setHotspot(val, oldVal);
    },
    loadScene(id){
                this.$store.dispatch("loadScene", id);
            },
  },
};
</script>

<style lang="less" scoped>
.mob-inject{
    padding: 0 !important;
}
</style>